import Vue from 'vue'
import domUtils from 'util/dom-utils'
import apiService from 'services/api-service'
import globalStore from 'init/global-store'
import globalConfig from 'init/global.config'
import QaComment from 'components/comment/comment'
import qaConfig from 'widgets/qa/qa.config'

import withRender from './comments-question.html'
import './question.scss'

/*
 * As of initial v5 development, all the qaConfig.comments settings are actually
 * not configurable by users, though we have coded this to get values from the
 * qaConfig object. V4 did not have any of these configurable and in fact was not
 * truncating comments but because of the way Comment is used in this and others
 * we thought it better to let it do so in v5.
 */
export default withRender(Vue.extend({
  data() {
    return {
      comments: [],
      globalStore,
      showComments: false
    }
  },
  components: {
    'tt-qa-comment': QaComment
  },
  computed: {
    currentSku() {
      return this.globalStore.sku
    },
    siteName() {
      return globalConfig.siteName
    },
    showActions() {
      return this.comments.length > qaConfig.comments.initialPageSize
    },
    showExpand() {
      return this.comments.length > qaConfig.comments.initialPageSize && !this.showComments
    },
    showHide() {
      return this.comments.length > 1 && this.showComments
    },
    commentsForDisplay() {
      if (!this.showComments) {
        return this.comments.slice(0, qaConfig.comments.initialPageSize)
      }
      return this.comments
    },
    truncateLength() {
      return qaConfig.comments.truncateLength
    },
    truncateAllowance() {
      return qaConfig.comments.truncateAllowance
    }
  },
  methods: {
    expandComments() {
      this.showComments = true
      domUtils.safeFocusRef(this.$refs, 'hideComments')
    },
    hideComments() {
      this.showComments = false
      domUtils.safeFocusRef(this.$refs, 'expandComments')
    },
    fetchData() {
      if (this.currentSku) {
        apiService.chatterComments({
          sku: this.currentSku,
          offset: 0,
          limit: qaConfig.comments.limit,
          sort: qaConfig.comments.sortOrder as 0 | 1,
          minCharCount: 0, // TT-10830: do not exclude comments based on length
          minWordCount: 0, // TT-10830: do not exclude comments based on length
          includeSyndicated: qaConfig.comments.includeSyndicated
        }).then((data) => {
          this.comments = data.comments
          this.$emit('commentsLoaded', (this.comments.length > 0 ? true : false))
        }).catch(() => {
          this.$emit('commentsLoaded', false)
        })
      }
    }
  },
  created() {
    this.fetchData()
  },
  watch: {
    currentSku() {
      this.fetchData()
    }
  }
}))



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/components/question/comments-question.ts